import environment, { EnvironmentVariables } from './environment';

const isMobile =
  environment?.get(EnvironmentVariables.PLATFORM, 'web') === 'mobile';

export { isMobile };
